export const followupShortcuts = [
  "/followup1",
  "/followup2",
  "/followup3",
  "/followup4",
  "/followup5",
  "/followup6",
];
